export default {
  submitText: '保存',
  emptyBtn: false,
  group: [
    {
      label: '房产信息',
      prop: 'group1',
      column: [
        {
          label: '上级结构',
          prop: 'parentObjectName',
          disabled: true,
          span: 12,
        },
        {
          label: '房间名称',
          prop: 'objectName',
          rules: [
            {
              required: true,
              message: '请输入节点名称',
              trigger: 'change',
            },
            { min: 1, max: 30, message: '长度在 1 到 30 个字符' }
          ],
          span: 12,
        },
        {
          label: '速记码',
          prop: 'shortCode',
          span: 12,
          rules: [
            { min: 1, max: 20, message: '长度在 1 到 20 个字符' }
          ]
        },
        {
          label: '房屋性质',
          prop: 'useType',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/base/property/getUseTypes?code=use_type&remark=1',
          props: { label: 'dictValue', value: 'dictKey' },
          rules: [
            {
              required: true,
              message: '请选择房屋性质',
            },
          ],
          span: 12,
        },
        {
          label: '使用面积',
          prop: 'usableArea',
          placeholder: '请输入 使用面积，单位m2',
          rules: [
            {
              required: true,
              message: '请输入使用面积',
            },
            {
              pattern: /(^[1-9](\d{0,3})?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/,
              message: '请输入整数最多4位，小数最多2位',
              trigger: 'change',
            },
          ],
          span: 12,
        },
        {
          label: '建筑面积',
          prop: 'floorage',
          display: true,
          placeholder: '请输入 建筑面积，单位m2',
          rules: [
            {
              required: true,
              message: '请输入建筑面积',
            },
            {
              pattern: /(^[1-9](\d{0,3})?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/,
              message: '请输入整数最多4位，小数最多2位',
              trigger: 'change',
            },
          ],
          span: 12,
        },
        {
          label: '户主姓名',
          prop: 'householdName',
          display: true,
          rules: [{ required: true, message: '请输入户主姓名' }, { min: 2, max: 20, message: `输入长度在 2 到 20 个字符` }],
          span: 12,
        },
        {
          label: '联系方式',
          prop: 'householdLinkPhone',
          display: true,
          rules: [{ required: true, message: '请输入联系方式' }, { pattern: /^1\d{10}$|^(\d{3,4}-)?\d{7,8}(-\d{1,4})?$/, message: '请输入正确的联系方式' }],
          span: 12,
        },
        {
          label: '房屋状态',
          prop: 'roomStatus',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=room_status',
          props: { label: 'dictValue', value: 'dictKey' },
          rules: [
            { required: true, message: '请选择房屋状态' }
          ],
          span: 12,
        },
        {
          label: '序号',
          prop: 'indexNum',
          rules: [
            {
              required: true,
              message: "请输入 序号"
            },
            { pattern: /^[1-9]\d{0,2}$/, message: '请输入不超过3位的正整数' }
          ],
          span: 12,
        },
      ]
    },
    {
      label: '成员管理',
      prop: 'group2',
      column: [],
    },
  ],
};
